import React from "react";
import { Box, Button, Container, Heading, Text, VStack, Badge } from "@chakra-ui/react";
import Header from "./Header";
import { useLocation, useNavigate } from "react-router-dom";

export default function LocationPermissionSuccess() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const ref = state?.ref || "";
  const id = state?.id || "";

  return (
    <Box bg="gray.50" minH="100vh">
      <Header />
      <Container maxW="container.sm" py={16}>
        <VStack spacing={6} textAlign="center">
          <Heading size="lg">Application submitted</Heading>
          <Text color="gray.600">Your location permission request has been received. Save this reference for tracking.</Text>
          {ref ? <Badge fontSize="lg" px={4} py={2} colorScheme="purple">{ref}</Badge> : null}
          {id ? <Text fontSize="sm" color="gray.500">Record #{id}</Text> : null}
          <Button colorScheme="blue" onClick={() => navigate("/")}>Back to home</Button>
        </VStack>
      </Container>
    </Box>
  );
}
